require('../style.css');
// todo 暂时先这样，回头封装一个设备判断的库。
var ua = navigator.userAgent,
    weixin = ua.match(/MicroMessenger/ig),
    QQ = ua.match(/QQ\//),
    isWeibo = ua.match(/WeiBo/i),
    PC = !/iphone|ipod|ipad|android/ig.test(ua),
    isAlipay = ua.match(/Alipay/),
    isAndroid=navigator.userAgent.match(/android/ig),
    isIos=navigator.userAgent.match(/iphone|ipod/ig),
    isIpad=navigator.userAgent.match(/ipad/ig),
    isIos9 = navigator.userAgent.match(/iphone os 9/ig),
    isIos10 = navigator.userAgent.match(/iphone os 10/ig);


var purePull = function (url) {
    // alert(url);
    if (isAndroid) {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        document.body.appendChild(iframe);
    } else {
        window.location.href = url;
    }
};

/**
 * 拉起规则：
 * 拉起分为两种方式：
 * 1.单纯的拉起，如果拉起不成功，尽量不去影响用户
 * 2.有目的的拉起，如果拉起失败，则跳转到app的下载中间页，引导用户进行下载。
 *
 * 对于第一种拉起方式，安卓在iframe调用apiUrl地址，ios直接指向apiUrl。
 *
 * 对于第二种拉起方式。以下规则需要测试！！
 * 拉起对于不同的浏览器，有不同的方式
 * 1.对于微信，qq 浏览器（安卓和ios），直接调用不带scheme参数的apiUrl进行拉起。
 * 2.对于ios下面，直接调用不带scheme参数的apiUrl进行拉起
 * 3.对于android其他浏览器，需要在iframe下面调用apiUrl进行拉起，
 *   并在1.5秒后，判断页面是否还显示（因为拉起成功的话，会跳转到app中，页面会被隐藏），如果页面还显示，则跳转到下载页。
 *   这个有个问题是，在拉起过程中如果弹出需要用户确认的对话框，有可能会导致跳转刷掉提示，导致用户无法拉起客户端，
 *   这里还需要测试。
 *   比较理想的是不用iframe，采用和ios一样的方式进行拉起，不过上次看视频（2016-12-05左右）那边做uc下面是有问题的。
 */

// options
//   aipUrl // 无线互联网开发的一个唤醒服务，可以通过此改地址进行app的唤醒和跳转到下载页。
//   protocoUrl // 直接调用app的协议进行拉起，功能单一，不智能
//   downloadUrl // 直接调用app的下载页，功能单一，不智能。

function publicClientAuto() {
    if (navigator.userAgent.indexOf("UCBrowser") > 0) {
        location.href = "https://api.iclient.ifeng.com/appdownload";
    }
}

var pull = function (options, onlyPull) {
    var url;
    if (onlyPull) {
        if (options.apiUrl) {
            url = options.apiUrl + '&scheme=1';
        } else {
            url = options.protocolUrl;
        }
        purePull(url);
    } else {
        url = options.apiUrl;
        // 如果是在微信或者在 QQ 浏览器（这个需要测试）中打开
        if (isIos || isIpad || weixin || QQ || isWeibo) {
            window.location.href = url;
        } else if (navigator.userAgent.indexOf("UCBrowser") > 0) {//UC需要跳转到中间页去拉起
            // setTimeout(function () {
            //     publicClientAuto();
            // }, 500);
            setTimeout(function () {
                location.href = '//p1.ifengimg.com/a/2017/0324/uc_down_v20170325.html?' + options.protocolUrl + '1';
            }, 1000);
        }
        else {
            // 在其他浏览器中
            url = options.protocolUrl;
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
            setTimeout(function () {
                if (document.hidden == false) {
                    window.location.href = options.downloadUrl;
                }
            }, 1500);
        }
    }
};


module.exports = pull;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.pullup/app/lib/pull.js